module.exports = __webpack_public_path__ + "static/img/add-card.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/add-card.png
// module id = 505
// module chunks = 0